import { format, parse } from 'date-fns';
import { getNextDay } from '../../../helpers/getNextDay';
import {
  allDatesFormat,
  dateTimeFallback,
  formatToAmPm,
  getTimeFormat,
  convertTimeObject,
} from 'common/dateFormatConfig';

export const getWeekends = (user) => {
  if (!user) return [];
  const userWorkDays = user.profile.shifts.weekDays;
  switch (userWorkDays) {
    case 'Sun-Thu':
      return [5, 6];
    case 'Mon-Fri':
      return [0, 6];
    case 'Tue-Sat':
      return [0, 1];
    default:
      return [];
  }
};

export const formatData = ({ values, user }, dateFormat = dateTimeFallback, getTimeFormatHook) => {
  const startHoursObj = [
    values.startDate,
    values.startHours,
    values.startMinutes,
    values.startAmPm,
  ];
  const startDate = parse(
    getTimeFormatHook(startHoursObj).formattedTimeDate,
    getTimeFormatHook(startHoursObj).formatForDateTimePars,
    new Date()
  );

  const endHoursObj = [values.endDate, values.endHours, values.endMinutes, values.endAmPm];

  const endDate = parse(
    getTimeFormatHook(endHoursObj).formattedTimeDate,
    getTimeFormatHook(endHoursObj).formatForDateTimePars,
    new Date()
  );

  return {
    type: values.type,
    userId: user._id,
    isPTO: values.isPTO,
    reason: values.reason,
    notes: values.notes,
    relativeName: values.relativeName,
    relationship: values.relationship,
    utcStartDate: startDate.toISOString(),
    startTime: {
      hour: values.startHours,
      minute: values.startMinutes,
    },
    endTime: {
      hour: values.endHours,
      minute: values.endMinutes,
    },
    utcEndDate: endDate.toISOString(),
  };
};

export const reasons = ['Vacation Day', 'Sick Leave', 'Bereavement', 'FMLA', 'Other'];
export const relations = ['Child', 'Grand-Parent', 'Parent', 'Sibling', 'Spouse', 'Other'];

export const getDefaultFormValues = ({ pto, shiftTime, dateFormat, is12Format }) => {
  const todayDate = new Date();
  const today = format(todayDate, dateFormat);
  const tomorrow = getNextDay(todayDate, dateFormat);

  const { hour, minute, amPm } = convertTimeObject(shiftTime, is12Format);

  return {
    notes: '',
    isPTO: !!(pto && pto.available),
    type: 'full',
    reason: reasons[0],
    startDate: today,
    startHours: String(Number(hour)),
    startMinutes: minute,
    startAmPm: amPm || formatToAmPm(hour),
    endDate: tomorrow,
    endHours: String(Number(hour)),
    endMinutes: minute,
    endAmPm: amPm || formatToAmPm(hour),
    relationship: '',
  };
};
